import { z } from 'zod';

/**
 * a common status that can be used across diff models.
 */
export const statusCommonSchema = z
  .enum(['active', 'pending', 'inactive', 'blocked'])
  .default('active');
export type StatusCommon = z.infer<typeof statusCommonSchema>;
